export default function AuthorizedAppsTab() {
    return (
        <h2>Authorized Apps</h2>
    );
}